import { styled } from 'stitches.config'

export const CtaBannerWrapper = styled('div', {
  '& h2': {
    width: '100%',
    maxWidth: '360px',

    '@bp2': {
      maxWidth: '840px',
    },
  },
})
